/** Fixed tag palette: distinct hues, each in five depths (1 lightest … 5 solid). Tokens live in styles.css. */
export const TAG_HUES = ["red", "orange", "amber", "lime", "green", "teal", "blue", "indigo", "violet", "pink", "gray"];
export const TAG_DEPTHS = [1, 2, 3, 4, 5];
export const TAG_HUE_LABELS = {
    red: "Красный", orange: "Оранжевый", amber: "Янтарный", lime: "Лайм", green: "Зелёный", teal: "Бирюзовый",
    blue: "Синий", indigo: "Индиго", violet: "Фиолетовый", pink: "Розовый", gray: "Серый",
};
export const TAG_DEPTH_LABELS = { 1: "очень светлый", 2: "светлый", 3: "средний", 4: "яркий", 5: "насыщенный" };
/**
 * The palette had three depths until 2026-10-27; their colours are now depths 1, 3 and 5 (same values).
 * A host that stored a three-depth id must translate it once (CRM: a migration of location_tags.color): `blue-2` → `blue-3`.
 */
export const LEGACY_DEPTH_MAP = { 1: 1, 2: 3, 3: 5 };
/** A three-depth id (`blue-2`) → the same colour in the five-depth palette (`blue-3`); anything else → null. */
export function upgradeLegacyTagColor(value) {
    const m = value.match(/^([a-z]+)-([123])$/);
    if (!m || !TAG_HUES.includes(m[1]))
        return null;
    return `${m[1]}-${LEGACY_DEPTH_MAP[Number(m[2])]}`;
}
export const ALL_TAG_COLORS = TAG_HUES.flatMap(hue => TAG_DEPTHS.map(depth => `${hue}-${depth}`));
export function isTagColor(value) {
    return typeof value === "string" && ALL_TAG_COLORS.includes(value);
}
export function parseTagColor(color) {
    const [hue, depth] = color.split("-");
    return { hue: hue, depth: Number(depth) };
}
export const tagColorLabel = (color) => { const { hue, depth } = parseTagColor(color); return `${TAG_HUE_LABELS[hue]}, ${TAG_DEPTH_LABELS[depth]}`; };
/** A stable default colour for an id (no gray, depth 1): the same record gets the same colour everywhere. */
export function tagColorFor(id, depth = 1) {
    const hues = TAG_HUES.filter(hue => hue !== "gray");
    const n = typeof id === "number" ? Math.abs(Math.trunc(id)) : [...id].reduce((sum, char) => (sum * 31 + char.charCodeAt(0)) >>> 0, 7);
    return `${hues[n % hues.length]}-${depth}`;
}
/** CSS variables that paint a chip/swatch in a palette colour. */
export function tagColorStyle(color) {
    const { hue } = parseTagColor(color);
    return {
        "--jui-chip-bg": `var(--jui-tag-${color}-bg)`, "--jui-chip-fg": `var(--jui-tag-${color}-fg)`,
        "--jui-swatch": `var(--jui-tag-${color}-bg)`, "--jui-swatch-fg": `var(--jui-tag-${color}-fg)`,
        "--jui-dot": `var(--jui-tag-${hue}-dot)`,
    };
}
